import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginData } from 'src/app/models/loginData';
import { LoginDataService } from 'src/app/services/login-data.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  hide = true;
  LoginData: LoginData;
  loginlist: LoginData[];

  constructor(private router: Router, public LoginDataForm: LoginDataService) {
    this.LoginData = new LoginData();
    this.loginlist = [];
  }
  ngOnInit(): void {
    const records = localStorage.getItem('loginlist');
    if (records !== null) {
      this.loginlist = JSON.parse(records);
    }
  }
  // getNewUser() 
  // {
  //   const oldRecords = localStorage.getItem('loginlist');
  //   if(oldRecords !== null) 
  //   {
  //     const loginlist = JSON.parse(oldRecords); // string to json obj
  //     return loginlist.length + 1;
  //   }
  //   else {
  //     return 1;
  //   }
  // }
  onSubmit() {
    const latestuser = this.LoginDataForm.getNewUser();
    this.LoginData.userid = latestuser;
    const oldRecords = localStorage.getItem('loginlist');
    if (oldRecords !== null) {
      const loginlist = JSON.parse(oldRecords);
      loginlist.push(this.LoginData);
      localStorage.setItem('loginlist', JSON.stringify(loginlist));  //obj to string
      this.router.navigate(['/dashboard']);
    }
    else {
      const userArr = [];
      userArr.push(this.LoginData);
      localStorage.setItem('loginlist', JSON.stringify(userArr));
    }
  }
}
